import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  formWrapper: {
    position: 'relative'
  },
  BasicInfoRow: {
    display: 'flex',
    alignItems: 'flex-start',
    // justifyContent: 'space-between',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    '& .MuiInputLabel-root': {
      color: theme.palette.text.primary,
      minWidth: 170,
      [theme.breakpoints.down('xs')]: {
        width: '100%'
      },
      [theme.breakpoints.up('sm')]: {
        margin: 0,
        minHeight: 40,
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(0.5),
        display: 'flex',
        alignItems: 'center',
        paddingRight: theme.spacing(2)
      }
    },
    '& .MuiFormControl-root': {
      width: '100%',
      [theme.breakpoints.down('xs')]: {
        width: '100%'
      }
    },
    '& .MuiFormGroup-root[role="radiogroup"]': {
      flexDirection: 'row',
      '& .MuiFormControlLabel-root': {
        marginBottom: theme.spacing(0)
      }
    },
    '& a': {
      display: 'block',
      width: '100%',
      textAlign: 'right'
    },
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap'
    },
    '& .ck.ck-toolbar': {
      direction: theme.direction === 'rtl' ? 'ltr' : 'ltr'
      // '& .ck-button__label': {
      //   textAlign: 'right !important'
      // }
    },
    '& .ck-editor__editable_inline': {
      minHeight: '200px',
      position: 'relative',
      padding: theme.spacing(1, 2) + '!important',
      '& p': {
        fontSize: theme.typography.pxToRem(16),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
      }
    },
    '& .ck-focused': {
      boxShadow: 'none !important'
    }
  },
  PageCKContent: {
    marginTop: theme.spacing(1),
    '&.Mui-error .ck-editor__editable_inline, &.Mui-error .cke_editor_content': {
      borderColor: theme.palette.error.main + '!important'
    }
  },
  SwitchWrapper: {
    marginTop: theme.spacing(1)
  },
  SubmitRow: {
    padding: theme.spacing(4, 0),
    textAlign: 'center'
  },
  AddAdminSubmit: {
    color: theme.palette.common.white,
    background: theme.palette.primary.light,
    border: 'none',
    padding: theme.spacing(1, 6),
    '&:disabled': {
      pointerEvents: 'none',
      opacity: 0.7
    },
    '&:hover, &:focus': {
      opacity: 0.7
    }
  }
}))
